module.exports = __webpack_public_path__ + "static/media/card_visa.96e6aca6.svg";